import { DpoAuditReportHistoryEntry } from '@dieterApi/dpo/useDpoAuditReportHistoryQuery';
import { Button } from '@mui/material';
import { Trash2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface AuditReportHistorySidebarProps {
  history: DpoAuditReportHistoryEntry[];
  selectedId: string | null;
  onSelect: (id: string) => void;
  onNewReport: () => void;
  onDelete: (id: string) => void;
}

export function AuditReportHistorySidebar({
  history,
  selectedId,
  onSelect,
  onNewReport,
  onDelete,
}: AuditReportHistorySidebarProps) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col h-full border-r bg-gray-50">
      <div className="p-4 border-b">
        <Button variant="contained" color="primary" fullWidth onClick={onNewReport}>
          {t('route.dpo.auditReport.newReport')}
        </Button>
      </div>

      <div className="flex-1 overflow-y-auto">
        {history.length === 0 ? (
          <div className="p-4 text-center text-gray-500">{t('route.dpo.auditReport.noHistory')}</div>
        ) : (
          <div className="divide-y">
            {history.map((entry) => (
              <div
                key={entry.id}
                className={`p-3 cursor-pointer hover:bg-gray-100 flex items-center justify-between ${
                  selectedId === entry.id ? 'bg-blue-50 border-l-4 border-blue-500' : ''
                }`}
                onClick={() => onSelect(entry.id)}
              >
                <div className="flex-1">
                  <div className="text-sm font-medium">
                    {t('route.dpo.auditReport.reportFrom', {
                      date: new Date(entry.createdAt).toLocaleDateString('de-DE'),
                    })}
                  </div>
                  <div className="text-xs text-gray-500">
                    {new Date(entry.createdAt).toLocaleTimeString('de-DE', {
                      hour: '2-digit',
                      minute: '2-digit',
                    })}
                  </div>
                </div>
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    onDelete(entry.id);
                  }}
                  className="ml-2 p-1 text-gray-400 hover:text-red-500"
                >
                  <Trash2 size={16} />
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
